import { render } from "./Department.vue?vue&type=template&id=e3e07d7c&scoped=true"
import script from "./Department.vue?vue&type=script&lang=js"
export * from "./Department.vue?vue&type=script&lang=js"

import "./Department.vue?vue&type=style&index=0&id=e3e07d7c&lang=scss&scoped=true"
import "./Department.vue?vue&type=style&index=1&id=e3e07d7c&lang=scss"

import exportComponent from "D:\\Project\\website-shuziyun\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e3e07d7c"]])

export default __exports__